import { render, staticRenderFns } from "./forgetPsd.vue?vue&type=template&id=07fbff0f&scoped=true"
import script from "./forgetPsd.vue?vue&type=script&lang=js"
export * from "./forgetPsd.vue?vue&type=script&lang=js"
import style0 from "./forgetPsd.vue?vue&type=style&index=0&id=07fbff0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fbff0f",
  null
  
)

export default component.exports